export const BOOKING_DATE_START_DATE = "2015/01/01";
//
export const DATE_PATTERN = "dd-MM-yyyy";
//
export const RESET_BOOKING_DATE = {
  startDate: new Date(BOOKING_DATE_START_DATE).toISOString(),
  endDate: new Date().toISOString(),
  key: "selection",
};
